import React from 'react';

import { convertStyleData } from '@utils/tools';
import { appMethod as app, appInstance } from '@utils/app';
import util from '@utils/util';

import CustomComponent from '../CustomComponent';

import './FormVesselCustomComponent.less';

export default class FormVesselCustomComponent extends React.Component {
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let _this = this;
    let newData = {};
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let content = pageInstance.data.eles[compindex].content;
    let buttonContent = '';
    let buttonIndex = '';
    for (let i = 0; i < content.length; i++) {
      if (content[i].type == 'form-button') {
        buttonContent = content[i];
        buttonIndex = i;
      }
    }
    // 绑定当前动态表单的对象字段
    const formData = appInstance.state.allData.form_data && appInstance.state.allData.form_data[customFeature.form];
    if (formData) {
      pageInstance.setData({
        ['eles[' + compindex + '].field_arr']: formData.field_arr
      })
    }
    if (buttonIndex === ''){
      return;
    }
    newData['eles[' + compindex + '].content[' + buttonIndex + '].can_use'] = 1;
    pageInstance.setData(newData);
    let param = {
      button_info: {
        'type': buttonContent.customFeature.effect || 1,
        'times': buttonContent.customFeature.frequency || -1,
        'button_id': customFeature.id
      }
    }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/isFormSubmitButtonValid',
      data: param,
      method: 'post',
      success: function (res) {
        newData = {};
        newData['eles[' + compindex + '].content[' + buttonIndex + '].can_use'] = res.data.can_use;
        newData['eles[' + compindex + '].buttonContent'] = buttonContent;
        pageInstance.setData(newData);
        if (res.data.can_use == 0 && buttonContent.customFeature.showPreviousData) {
          _this.requestLastForm(compindex, pageInstance);
        }
      }
    })
  }

  requestLastForm = (compindex, pageInstance) => {
    let content = pageInstance.data.eles[compindex].content;
    app.sendRequest({
      url: '/index.php?r=AppData/GetDatasByUserToken',
      data: { form: pageInstance.data.eles[compindex].customFeature.form },
      method: 'post',
      success: res=> {
        let preFormData = res.data[0].form_data;
        let asForm = 'eles[' + compindex + '].form_data';
        let asContent = 'eles[' + compindex + '].content';
        content.map(item => {
          let item_id = item.customFeature.segment;
          let item_type = item.type;
          for (let key in preFormData) {
            if (key == item_id) {
              switch(item_type) {
                case 'select-ele':
                  if(item.customFeature.type == 1) {
                    let selectArr = [];
                    for(let i = 0; i < item.content.lists.length; i++) {
                      if(item.content.lists[i] == preFormData[key]) {
                        selectArr[i] = i;
                      }else {
                        selectArr[i] = null;
                      }
                    }
                    item.selectedValue = selectArr;
                  }
                  if (item.customFeature.multiSelection) {
                    let selectArr = [], selectedData = {"checkLength" : 0 };
                    for (let i = 0; i < item.content.lists.length; i++) {
                      if (preFormData[key].indexOf(item.content.lists[i]) >= 0) {
                        selectArr[i] = true;
                        selectedData.checkLength ++;
                      }else {
                        selectArr[i] = false;
                      }
                    }
                    item.content.selectArr = selectArr;
                    item.selectedData = selectedData;
                  }
                  break;
                case 'time-ele':
                  let time = preFormData[key].split(" ");
                  item.date = time[0];
                  item.time = time[1];
                  break;
                case 'drop-down':
                  let asDrop = 'eles[' + compindex + '].dropDown';
                  let drop = preFormData[key].split(",");
                  let dropDown = {};
                  dropDown[item_id] = drop;
                  pageInstance.setData({ [asDrop]: dropDown });
                  break;
              }
            }
          }
        })
        pageInstance.setData({ 
          [asForm]: preFormData,
          [asContent]: content
        });
      }
    })
  }

  submitForm = () => {
    let pageInstance = app.getAppCurrentPage();
    let _this = this;
    let compindex = this.props.index;
    let compData = this.props.data;
    let form = this.props.data.customFeature.form;
    let form_data = compData.form_data;
    let field_info = compData.field_info;
    let content = compData.content;
    let form_id = compData.customFeature.id;
    let buttonContent = compData.buttonContent;
    if (!buttonContent) {
      console.log('提交按钮信息有误');
      return;
    }
    let button_info = {
      'type': buttonContent.customFeature.effect,
      'times': buttonContent.customFeature.frequency,
      'pay': buttonContent.customFeature.pay,
      'price': buttonContent.customFeature.price,
      'isDiscount': buttonContent.customFeature.discount,
      'button_id': form_id,
      'operation': ''
    };
    let url = '';
    let contentTip = '';
    let formEleType = [
      'input-ele',
      'textarea-ele',
      'grade-ele',
      'select-ele',
      'upload-img',
      'time-ele',
      'drop-down',
      'pic-options',
      'address-ele',
      'anonymous-ele',
      'upload-video'
    ];

    switch (buttonContent.customFeature.action) {
      case 'integral':
        button_info['operation'] = 1;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['interests'] || 0) + '积分';
        button_info['num'] = buttonContent.customFeature['interests'];
        url = "myIntegral";
        break;
      case 'scratch':
        button_info['operation'] = 2;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['scratch'] || 0) + '刮刮乐次数';
        button_info['num'] = buttonContent.customFeature['scratch'];
        url = "scratch";
        break;
      case 'break-egg':
        button_info['operation'] = 3;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['break-egg'] || 0) + '砸金蛋次数';
        button_info['num'] = buttonContent.customFeature['break-egg'];
        url = "goldenEggs";
        break;
      case 'turntable':
        button_info['operation'] = 4;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['turntable'] || 0) + '大转盘次数';
        button_info['num'] = buttonContent.customFeature['turntable'];
        url = "uckyWheelDetail";
        break;
      case 'coupon':
        button_info['operation'] = 5;
        button_info['obj_id'] = buttonContent.customFeature['couponId'];
        button_info['num'] = buttonContent.customFeature['coupon-num'];
        contentTip = '提交成功，增加' + (buttonContent.customFeature['coupon-num'] || 0) + '优惠券';
        url = "couponList";
        break;
      case 'vip-card':
        button_info['operation'] = 6;
        button_info['obj_id'] = buttonContent.customFeature['vipId'];
        contentTip = '提交成功，增加会员卡一张';
        url = "vipCardList";
        break;
      case 'inner-link':
        button_info['operation'] = 'inner-link';
        let innerParam = buttonContent.customFeature;
        url = innerParam['inner-page-link'];
        break
      case 'plugin-link':
        button_info['operation'] = 'plugin-link';
        let pluginParam = buttonContent.customFeature;
        url = pluginParam['plugin-page'];
        break;
    }

    for (let index = 0; index < content.length; index++) {
      if (formEleType.indexOf(content[index].type) == -1) {
        continue;
      }
      let customFeature = content[index].customFeature;
      let segment = customFeature.segment;
      let fieldItem = compData.field_arr.find((item) => item.field == segment);
      let ifMust = fieldItem ? Number(fieldItem.necessary) : 0;
      let fieldName = fieldItem ? fieldItem.name : '';
      switch (content[index].type) {
        case 'drop-down':
        case 'anonymous-ele':
          if ((!form_data || !form_data[segment] || form_data[segment].length < content[index].customFeature.contents.length || form_data[segment].split(',').includes('')) && ifMust == 1) {
            app.showModal({
              content: fieldName + ' 没有填写'
            });
            return;
          }
          break;
        case 'pic-options':
          if (ifMust == 1) {
            if (content[index].customFeature.multiSelection) {
              if (!form_data || !form_data[segment] || form_data[segment].length < content[index].customFeature.minSelect) {
                app.showModal({
                  content: content[index].customFeature.name + '是多选必选项'
                })
                return;
              }
            } else {
              if (!form_data || !form_data[segment]) {
                app.showModal({
                  content: content[index].customFeature.name + '是必选项'
                })
                return;
              }
            }
          } else {
            if (content[index].customFeature.multiSelection && form_data && form_data[segment] && form_data[segment].length && form_data[segment].length < content[index].customFeature.minSelect) {
              app.showModal({
                content: content[index].customFeature.name + '至少选择' + content[index].customFeature.minSelect + '项'
              })
              return;
            }
          }
          break;
        case 'input-ele':
        case 'textarea-ele':
          if (ifMust == 1) {
            if (!form_data || !form_data[segment] || form_data[segment].length == 0) {
              app.showModal({
                content: fieldName + ' 没有填写'
              });
              return;
            } else {
              if (_this.formRegex(content[index].customFeature.dataType, form_data[segment])) {
                return;
              }
            }
          } else {
            if (form_data && segment && form_data[segment] && form_data[segment].length && _this.formRegex(content[index].customFeature.dataType, form_data[segment])) {
              return;
            }
          }
          break;
        case 'select-ele':
          if (content[index].customFeature.type === undefined) { break }
          else if (content[index].customFeature.type === 0) {
            if (ifMust == 1) {
              if (content[index].customFeature.multiSelection) {
                if (!form_data || !form_data[segment] || content[index].selectedData.itemLength < content[index].customFeature.minSelect) {
                  app.showModal({
                    content: content[index].content.title + '是多选必选项'
                  })
                  return;
                }
              } else {
                if (!form_data || !form_data[segment]) {
                  app.showModal({
                    content: content[index].content.title + '是必选项'
                  })
                  return;
                }
              }
            } else {
              if (content[index].customFeature.multiSelection && form_data && form_data[segment] && content[index].selectedData.itemLength && content[index].selectedData.itemLength < content[index].customFeature.minSelect) {
                app.showModal({
                  content: content[index].content.title + '至少选择' + content[index].customFeature.minSelect + '项'
                })
                return;
              }
            }
          } else if (content[index].customFeature.type === 1) {
            if (!content[index].selectedValue) {
              if (ifMust == 1) {
                app.showModal({
                  content: content[index].content.title + ' 没有填写'
                });
                return;
              }
            } else {
              let arrLength = 0;
              for (let i = 0; i < content[index].selectedValue.length; i++) {
                if (content[index].selectedValue[i] != null) { arrLength++ }
              }
              if (ifMust == 1) {
                if (content[index].customFeature.multiSelection) {
                  if (!form_data || !form_data[segment] || arrLength < content[index].customFeature.minSelect) {
                    app.showModal({
                      content: content[index].content.title + '是多选必选项'
                    })
                    return;
                  }
                } else {
                  if (!form_data || !form_data[segment]) {
                    app.showModal({
                      content: content[index].content.title + '是必选项'
                    })
                    return;
                  }
                }
              } else {
                if (content[index].customFeature.multiSelection && form_data && form_data[segment] && arrLength && arrLength < content[index].customFeature.minSelect) {
                  app.showModal({
                    content: content[index].content.title + '至少选择' + content[index].customFeature.minSelect + '项'
                  })
                  return;
                }
              }
            }
          }
          break;
        case 'time-ele':
          if ((!form_data || !form_data[segment] || form_data[segment].length == 0) && ifMust == 1) { // 提示错误
            app.showModal({
              content: fieldName + ' 没有填写'
            });
            return;
          }
          if (!content[index].customFeature.ifAllDay && ((content[index].date && !content[index].time) || (!content[index].date && content[index].time))) {
            app.showModal({
              content: '请选择具体时间'
            });
            return;
          }
          break;
        default:
          if (ifMust == 1 && (!form_data || !form_data[segment] || form_data[segment].length == 0)) { // 提示错误
            app.showModal({
              content: fieldName + ' 没有填写'
            });
            return;
          }
          break;
      }
    }

    if (pageInstance.submitting) return;
    let countNum = 0;
    let countEmptyNum = 0;
    if (!form_data) {
      app.showModal({
        content: '数据为空'
      });
      return;
    } else {
      for (let i in form_data) {
        countNum++;
        if (form_data[i] && typeof form_data[i] == 'number') {
          continue;
        }
        if (!form_data[i] || (form_data[i] instanceof Array && form_data[i].length == 0)) { countEmptyNum++ }
      }
      if (countNum == countEmptyNum) {
        app.showModal({
          content: '数据为空'
        });
        return;
      }
    }
    pageInstance.submitting = true;

    let submitData = {
      button_info: button_info,
      form: form,
      form_data: form_data,
      is_transfer_order: button_info.pay ? 1 : 0
    };

    _this.submitFormRequest({
      url: url,
      data: submitData,
      compindex: compindex,
      contentTip: contentTip
    })
  }

  submitFormRequest = (options) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=AppData/addData',
      data: options.data,
      method: 'POST',
      success: function (res) {
        if (options.data.button_info.pay){
          options.data.form_data_id = res.data;
          _this.submitFormByPay({
            compindex: options.compindex,
            price: options.data.button_info.price,
            isDiscount: options.data.button_info.isDiscount,
            submitData: options.data,
            url: options.url,
            contentTip: options.contentTip
          });
          return
        };
        _this.addFormDataSuccess(options,res)
      },
      complete: function () {
        pageInstance.submitting = false;
      }
    })
  }

  submitFormByPay = (options) => {
    let pageInstance = app.getAppCurrentPage();
    let _data = {  };
    if (!options.isDiscount) {
      _data = {
        price: options.price,
        is_balance: 0,
        selected_benefit: {
          no_use_benefit: 1
        }
      }
    } else {
      _data = {
        price: options.price,
        is_balance: 0
      }
    }
    let formInfo = {
      calculData: _data,
      isDiscount: options.isDiscount,
      price: +options.price,
      submitData: options.submitData,
      show: true,
      logo: app.globalData.appLogo,
      name: app.getAppTitle()
    };
    pageInstance.setData({
      formInfo: formInfo
    });
    pageInstance.formPayRef.current.show({
      formInfo: formInfo
    })
    pageInstance.formPayRef.current.calculateTotalPrice({
      compindex: options.compindex,
      url: options.url,
      contentTip: options.contentTip,
      data: options.submitData
    });
  }

  addFormDataSuccess = (options, res) => {
    let pageInstance = app.getAppCurrentPage();
    this.init(options.compindex, pageInstance);
    if (options.data.button_info['operation'] === 'inner-link' || options.data.button_info['operation'] === 'plugin-link') {
      app.showToast({
        title: '提交成功',
        icon: 'success',
        duration: 3000,
        success: function () {
          if (options.url) {
            app.turnToPage(options.url);
          }
        }
      });
      return;
    }
    if (!res.msg) {
      app.showModal({
        content: options.contentTip || '提交成功',
        confirmText: options.data.button_info['operation'] ? '去查看' : '确认',
        confirm: function () {
          if (options.url) {
            app.turnToPage(options.url);
          }
        }
      });
    } else {
      app.showModal({
        content: res.msg
      });
    }
  }

  formRegex = (dataType, data) => {
    switch (dataType) {
      case 'phone':
        if (!util.isPhoneNumber(data)) {
          app.showModal({
            content: '请输入正确的手机号'
          });
          return true;
        }
        break;
      case 'IDcard':
        if (!(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/.test(data) || /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(data))) {
          app.showModal({
            content: '请输入正确的身份证'
          });
          return true;
        }
        break;
      case 'email':
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(data)) {
          app.showModal({
            content: '请输入正确的邮箱'
          });
          return true;
        }
        break;
      case 'chinese':
        if (!/^[\u4e00-\u9fa5]*$/.test(data)) {
          app.showModal({
            content: '请输入中文'
          });
          return true;
        }
        break;
      case 'number':
        if (!/^[0-9]*$/.test(data)) {
          app.showModal({
            content: '请输入数字'
          });
          return true;
        }
        break;
      case 'english':
        if (!/^[a-zA-Z]*$/.test(data)) {
          app.showModal({
            content: '请输入英文'
          });
          return true;
        }
        break;
      default:
        return false;
        break;
    }
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 组件内容处理
     */  
    const content = data.content;
    /**
     * 返回组件
     */ 
    return(
      <div className="custom-component form-vessel" style={styleObj}>
        {content.map((componentData, componentIndex) => 
          <CustomComponent
            key={componentIndex}
            index={componentIndex}
            data={componentData}
            onSubmit={this.submitForm}
            formCompindex={this.props.index}
            form_data={data.form_data}
          />
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/form-vessel-custom-component/FormVesselCustomComponent.jsx